// extracted by mini-css-extract-plugin
module.exports = {"container":"PrintFrame_container__i7jHg"};